module.exports = __webpack_public_path__ + "64145cf9df520c486ad8cab460ab997a.svg";